import { ItemPos } from "@components/global/Reorder2Dv2/types";
import { IRackItem, IRackItemBase } from "./RackItem/RackItem.props";

// export type TypePartialRackItems = (IRackItem | null | undefined)[];
export interface IMergedSection extends IRackItem {
  readonly merged: boolean;
}

export enum RACK_SECTION_TYPE {
  EMPTY = 1,
  NULL = -1,
  MINER = 0,
}
export interface IRackSection extends IRackItemBase { }
export type TypePartialRackItem = IRackItem | IMergedSection | IRackSection;

export const isRackItem = (item: any): item is IRackItem =>
  (item as IRackItem)?.user_id !== undefined;

export const isMinerItem = (item: any): item is IRackItem =>
  (item as IRackItem)?.miner_id !== undefined;

export interface IRackTable {
  readonly id: string;
  readonly rack_id: string;
  readonly rack_items: TypePartialRackItem[];
  readonly rack_type: [number, number];
  readonly found?: boolean;
}

export const isIRackTable = (item: any): item is IRackTable => Array.isArray((item as IRackTable)?.rack_items);

export interface IReceivedRackTable extends IRackTable {
  readonly x: number;
  readonly y: number;
}

export interface IPositionedRackTable extends IRackTable {
  readonly rack_pos: ItemPos;
}

export const isPostitionedRackTable = (
  r: IRackTable
): r is IPositionedRackTable =>
  (r as IPositionedRackTable).rack_pos !== undefined;

export interface IRackProps { }
